import Image from "next/image";
import Link from "next/link";
import { Col, Container, Nav, NavItem, Row } from "reactstrap";

const FooterSection = () => {
  return (
    <footer className="footer-2">
      <div className="custom-container">
        <Row className="row">
          <Col xs="12">
            <div className="footer-main-contian">
              <Row>
                <Col lg="3" md="12">
                  <div className="footer-left">
                    <div className="footer-logo">
                      {["light"].map((variant) => (
                        <Image
                          key={variant}
                          src={`/images/logo/logo-${variant}.png`}
                          className={`img-fluid ${variant}`}
                          alt="logo"
                          width={400}
                          height={50}
                        />
                      ))}
                    </div>
                    <div className="footer-detail">
                      <p>
                        New Zone es un centro comercial inteligente que
                        transformará la forma de comprar productos importados en
                        Paraguay. ¡Explora un nuevo mundo de compras, con
                        facilidad!
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg="9" md="12">
                  <div className="footer-right ">
                    <Row
                      className="row"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                        padding: "4vh 0",
                      }}
                    >
                      {/* <Col xs="12">
                        <div className="subscribe-section">
                          <div className="row">
                            <div className="col-md-5 ">
                              <div className="subscribe-block">
                                <div className="subscrib-contant ">
                                  <h4>Suscribíte a la newsletter</h4>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-7 ">
                              <div className="subscribe-block">
                                <div className="subscrib-contant">
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">
                                        <i className="fa fa-envelope-o"></i>
                                      </span>
                                    </div>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      placeholder="tu correo..."
                                    />
                                    <div className="input-group-prepend">
                                      <span className="input-group-text telly">
                                        <i className="fa fa-telegram"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col> */}
                      <Col md="12">
                        <div className="footer-box mt-3">
                          <Nav
                            horizontal="true"
                            style={{
                              justifyContent: "center",
                            }}
                          >
                            <NavItem>
                              <Link
                                href="/acerca_de_nosotros"
                                style={{
                                  color: "var(--bs-black)",
                                  fontWeight: "bold",
                                  margin: "0 10px",
                                }}
                              >
                                Acerca de nosotros
                              </Link>
                            </NavItem>
                            <NavItem>
                              <Link
                                href="https://recruitment.newzone.com.py/"
                                style={{
                                  color: "var(--bs-black)",
                                  fontWeight: "bold",
                                  margin: "0 10px",
                                }}
                              >
                                Trabaja con nosotros
                              </Link>
                            </NavItem>

                            <NavItem>
                              <Link
                                href="/terminos_y_condiciones"
                                style={{
                                  color: "var(--bs-black)",
                                  fontWeight: "bold",
                                  margin: "0 10px",
                                }}
                              >
                                Terminos y condiciones
                              </Link>
                            </NavItem>
                            <NavItem>
                              <Link
                                href="/bases_y_garantias"
                                style={{
                                  color: "var(--bs-black)",
                                  fontWeight: "bold",
                                  margin: "0 10px",
                                }}
                              >
                                Bases y garantías
                              </Link>
                            </NavItem>
                            <NavItem>
                              <Link
                                href="/politicas_de_perfumes"
                                style={{
                                  color: "var(--bs-black)",
                                  fontWeight: "bold",
                                  margin: "0 10px",
                                }}
                              >
                                Políticas de perfumes
                              </Link>
                            </NavItem>
                          </Nav>
                        </div>
                        {/* <div className="col-md-6">
                              <div className="footer-box footer-contact-box">
                                <div className="footer-title">
                                  <h5>Contactenos</h5>
                                </div>
                                <div className="footer-contant">
                                  <ul className="contact-list">
                                    <li>
                                      <i className="fa fa-map-marker"></i>
                                      <span>
                                        big deal store demo store <br />{" "}
                                        <span> india-3654123</span>
                                      </span>
                                    </li>
                                    <li>
                                      <i className="fa fa-phone"></i>
                                      <span>call us: 123-456-7898</span>
                                    </li>
                                    <li>
                                      <i className="fa fa-envelope-o"></i>
                                      <span>email us: support@bigdeal.com</span>
                                    </li>
                                    <li>
                                      <i className="fa fa-fax"></i>
                                      <span>fax 123456</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div> */}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>

      <div className="app-link-block  bg-transparent">
        <Container>
          <Row
            className="py-5"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              xs="6"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="app-item-group ">
                <div className="social-block">
                  <h6 className="my-2">Seguinos</h6>
                  <ul className="social">
                    <li>
                      <Link href="#">
                        <i className="fa fa-facebook"></i>
                      </Link>
                    </li>

                    <li>
                      <Link href="#">
                        <i className="fa fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link href="#">
                        <i className="fa fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col
              xs="6"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p className="my-2">Desarrollado por:</p>
              <Image src="/images/exo.png" width={100} height={40} alt="logo" />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="sub-footer">
        <Container>
          <Row>
            <Col xs="12">
              <div className="sub-footer-contain">
                <p>
                  <span>&copy; {new Date().getFullYear()} </span> New Zone All
                  Todos los derechos reservados.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default FooterSection;
